import styled from 'styled-components';

export const CardWrapper = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  padding: var(--spacing-4);
  border-radius: var(--border-radius-12);
  background-color: var(--color-bg-fill-secondary);
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  align-items: center;
  border: 1px solid transparent;
  gap: var(--spacing-16);
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

  &:hover {
    background-color: ${({ isDisabled }) =>
      isDisabled
        ? 'var(--color-bg-fill-secondary)'
        : 'var(--color-bg-fill-secondary-hover)'};
    border-color: ${({ isDisabled }) =>
      isDisabled ? 'transparent' : 'var(--color-border-selector)'};
  }
`;

export const CardImage = styled.img`
  width: 72px;
  height: 72px;
  border-radius: var(--border-radius-8);
  object-fit: cover;
  flex-shrink: 0;
`;
